export default {
	align: {
		page: 1,
		testimonial: 2,
		bubble: 3,
		details: 4,
		text: 5
	}
};